<div class="row justify-content-center align-items-center main-row">
    <div class="col centered">
        <router-outlet></router-outlet>
    </div>
</div>
